export function normalizeBotMarkdownLineBreaks(text: string): string {
  const normalized = text.replace(/\r\n/g, '\n').replace(/\\n/g, '\n');

  return normalized.replace(/([^\n])\n(?!\n)/g, '$1  \n');
}

/** Canonicalize any casing of the brand name to "DISGENET". */
export function normalizeDisgenetBrandName(text: string): string {
  return text.replace(/\bdisgenet\b/gi, 'DISGENET');
}

export function normalizeBotMarkdown(text: string): string {
  return normalizeBotMarkdownLineBreaks(normalizeDisgenetBrandName(text.trim()));
}
